import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { NgForm } from '@angular/forms';
import { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { SharedService } from 'src/app/core/services';
import { FileDoc, WizardStep, Checklist } from 'src/app/core/components';
import { takeUntil } from 'rxjs/operators';
import { OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { LicencesService } from '../licences.service';
import { isNullOrUndefined } from 'util';
import { MasterItemCode, NatureOfLicenceCode } from '../../contractor.enum';
import { GLOBAL } from 'src/app/app.globals';
import * as moment from 'moment';

const dateFormat = 'DD-MM-YYYY';
export const MY_MOMENT_FORMATS = {
  parseInput: dateFormat,
  fullPickerInput: dateFormat,
  datePickerInput: dateFormat,
  timePickerInput: dateFormat,
  monthYearLabel: dateFormat,
  dateA11yLabel: dateFormat,
  monthYearA11yLabel: dateFormat,
};

@Component({
  selector: 'app-licenses-form',
  templateUrl: './licenses-form.component.html',
  styleUrls: ['./licenses-form.component.css'],
  providers: [{ provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS }]
})
export class LicencesFormComponent implements OnInit, OnDestroy {

  @ViewChild('licenseForm') public licenseForm: NgForm;
  // @ViewChild('select') select: NgSelectComponent;

  public checkList: Checklist[] = [];
  public wizardSteps: WizardStep[] = [];
  public stateList: any[] = [];
  public natureOfLicenseList: any = [];
  public companyList: any[] = [];
  public plantList: any[] = [];
  public contractorWorkOrderList: any[] = [];
  public contractorList: any[] = [];
  public subContractorList: any[] = [];
  public subContractorWorkOrderList: any[] = [];
  public statuses: any[] = [];
  public natureOfWorkList: any[] = [];
  public verifyByList: any[] = [];
  // datepicker control config
  public datePickerPlaceHolder: string;
  public datePickerPickerMode: string;
  // selector component config
  public contractorConfig: any;
  public subContractorConfig: any;
  public workOrderConfig: any;
  public subContractorWOConfig: any;
  public editMode = false;
  @ViewChild('dialogerror') public dialogerror: SwalComponent;
  public alertOption: SweetAlertOptions = {};
  public isSubContractor = false;
  public documentTypes = [];
  public uploadedFiles: FileDoc[] = [];
  public isValidStartDate = false;
  private documentTypeDefaultMandatoryMap: Record<string, boolean> = {};
  private licenseDocumentRules: Record<string, string[]> = {
    'new license': ['labour license'],
    'renew license': ['labour license'],
    acknowledgment: ['labour license acknowledgment'],
    amendment: ['labour license amendment'],
    'amendment for renewal': ['labour license amendment'],
  };

  public minDate = new Date();
  public minEndDate: Date;
  public maxEndDate: Date;

  private onDestroy: Subject<any>;
  // private license: any = {};
  logHelperService: any;
  licenceno: any;
  headerTitleName: string = '';
  public tempdate = false;
  public status = false;
  public isverified = false;
  public verifiedby = false;
  public allowedFileTypes: any = '';
  public maxSizeAllowed: any = '';
  public allowedIssueDate: any = '';
  public isDocumentStepTouched = false;
  globalSettings: any;
  isContractor: any = false;
  private lastCheckedLicenseNo: string = '';

  public licenseMainData: any = {};
  public licenseWorkOrderData: any = {};
  public licenseNatureOfWorkData: any[] = [];
  public licenseDocumentData: any[] = [];
  public licenseFormDataSnapshot: any;

  public get isAcknowledgmentNatureSelected(): boolean {
    if (!this.licenseForm || !this.licenseForm.controls) {
      return false;
    }
    const licenseControl = this.licenseForm.controls['LicenseTypeMasterList_Code'];
    if (!licenseControl) {
      return false;
    }
    return licenseControl.value === NatureOfLicenceCode.Acknowledgment;
  }


  constructor(
    private sharedService: SharedService,
    private licenseService: LicencesService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.onDestroy = new Subject();
    this.datePickerPlaceHolder = this.sharedService.datePickerSettings.placeHolder;
    this.datePickerPickerMode = this.sharedService.datePickerSettings.pickerMode;
  }

  ngOnInit() {
    this.sharedService.globalMasterSettingData().subscribe((res: any) => {
      if (res) {
        this.globalSettings = res.Data.Table;
        this.maxSizeAllowed = Number(this.globalSettings.find(item => item.Code === 'DOCSIZELIC1').Value) * 1024;
        this.allowedFileTypes = this.globalSettings.find(item => item.Code === 'DOCFORMATLIC1').Value;
        this.allowedIssueDate = this.globalSettings.find(item => item.Code === 'MOD119PG192LICDSVSTD').Value;
      }
    });
    const roles = JSON.parse(localStorage.getItem('Role'));
    this.isContractor = roles.some(item => item.Role_Code === 119);
    if (this.checkContractorType()) {
      this.bindWizardSteps();
      setTimeout(() => {
        this.getLicense();
        this.getDocumentTypes();
        // this.bindCheckList();
      }, 10);
    }

    // tslint:disable-next-line: variable-name
    // tslint:disable-next-line: prefer-const
    let roleCode = JSON.parse(localStorage.getItem('Role'))[0].Role_Code;
    const userId = GLOBAL.USER_ID;
    // tslint:disable-next-line: triple-equals
    if (roleCode == 118 || roleCode == 103 || roleCode == 104 || roleCode == 101) {
      this.tempdate = true;
    }
    // tslint:disable-next-line: brace-style
    else {
      this.tempdate = false;
    }
    if (roleCode === 119) {

      this.getContractorsSelectedByDefault(userId, roleCode);
    } else {
      this.getContractors();
    }
  }

  getContractorsSelectedByDefault(userId: any, roleCode: any) {

    this.licenseService.getContractorsbydefault(userId, roleCode).subscribe((response: any[]) => {
      console.log('getContractors response', response);
      this.contractorList = response;
      
      // Only set contractor value if we have existing data (edit mode)
      if (this.licenseMainData.ParentContractorVendor_Code) {
        this.licenseForm.controls['ParentContractorVendor_Code'].setValue(this.licenseMainData.ParentContractorVendor_Code);
        this.getContractorWorkOrder(this.licenseMainData.ParentContractorVendor_Code);
      }
      // For contractor role, auto-select if only one contractor (this is business logic)
      else if (this.contractorList.length === 1) {
        this.licenseForm.controls['ParentContractorVendor_Code'].setValue(this.contractorList[0].ContractorVendor_Code);
        // Trigger contractor change event to load work orders properly
        this.onContractorChange(this.contractorList[0]);
      }
    });
  }

  public onCompanyChange(): void {
    const companyCode = this.licenseForm.controls['Company'].value;
    const stateCode = this.licenseForm.controls['State_Code'].value;
    
    // Clear plants when company changes
    this.plantList = [];
    this.licenseForm.controls['Plants'].setValue(null);
    
    if (companyCode && stateCode) {
      this.getPlants(companyCode, stateCode);
    }
  }

  public ngOnDestroy() {
    this.onDestroy.next(true);
    // window.removeEventListener('scroll', this.onScroll, true);
  }

  selectedState: any
  public onStateChange(selectedState: any): void {
    this.selectedState = selectedState;
    
    // Clear plant selection when state changes
    this.plantList = [];
    this.licenseForm.controls['Plants'].setValue(null);
    
    const stateCode = this.licenseForm.controls['State_Code'].value;
    const companyCode = this.licenseForm.controls['Company'].value;
    
    if (!stateCode) {
      // If state is removed, clear plants
      this.plantList = [];
      this.licenseForm.controls['Plants'].setValue(null);
      return;
    }
    
    // Auto-select company if only one is available and not already selected
    if (stateCode && !companyCode && this.companyList.length === 1) {
      this.licenseForm.controls['Company'].setValue(this.companyList[0].Company_Code);
      this.getPlants(this.companyList[0].Company_Code, stateCode);
    }
    // If both state and company are selected, load plants
    else if (stateCode && companyCode) {
      this.getPlants(companyCode, stateCode);
    }
  }
  selectedContractorData: any
  public onContractorChange(data: any): void {
    this.isContractorSelected = true
    this.selectedContractorData = data

    // Clear work orders when contractor is removed
    this.contractorWorkOrderList = [];
    this.subContractorList = [];
    this.subContractorWorkOrderList = [];
    this.licenseForm.controls['ParentWorkOrderCode'].setValue(null);
    this.licenseWorkOrderData.ParentWorkOrder_Code = null;
    
    if (this.isSubContractor) {
      this.licenseForm.controls['ContractorVendor_Code'].setValue(null);
      this.licenseMainData.ContractorVendor_Code = null;
      this.licenseForm.controls['ChildWorkOrderCode'].setValue(null);
      this.licenseWorkOrderData.ChildWorkOrder_Code = null;
    }

    if (!data) return;
    
    if (this.licenseMainData.ParentContractorVendor_Code) {
      this.licenseMainData.ParentContractorVendor_Code = data.ContractorVendor_Code;
    }
    
    const contractorCode = this.licenseForm.controls['ParentContractorVendor_Code'].value;
    if (contractorCode) {
      this.getContractorWorkOrder(contractorCode);
    }
  }

  selectedWorkOrderData: any
  public onContractorWOChange(data: any): void {
    this.selectedWorkOrderData = data
    if (!data) return;
    if (this.licenseWorkOrderData.ParentWorkOrder_Code) {
      this.licenseWorkOrderData.ParentWorkOrder_Code = data.WorkOrder_Code;
    }
    if (this.isSubContractor) {
      this.licenseForm.controls['ContractorVendor_Code'].setValue(null);
      this.licenseForm.controls['ChildWorkOrderCode'].setValue(null);
      this.licenseMainData.ContractorVendor_Code = null;
      this.licenseWorkOrderData.ChildWorkOrder_Code = null;
    }
    this.subContractorList = [];
    this.subContractorWorkOrderList = [];
    const parentWorkOrderCode = this.licenseForm.controls['ParentWorkOrderCode'].value;
    const contractorCode = this.licenseForm.controls['ParentContractorVendor_Code'].value;

    if (parentWorkOrderCode && contractorCode && this.isSubContractor) {
      this.getSubContractorsByWorkOrder(contractorCode, parentWorkOrderCode);
    }
  }

  public onWorkOrderFocus(): void {
    const contractorCode = this.licenseForm.controls['ParentContractorVendor_Code'].value;
    const plantCode = this.licenseForm.controls['Plants'].value;
    
    if (!contractorCode || !plantCode) {
      this.showAlert('error', 'Please select Contractor and Plant first before selecting Work Order.', 'Error!!!');
    }
  }

  public onSubContractorChange(data: any): void {

    // Clear sub-work-order when sub-contractor is removed
    this.subContractorWorkOrderList = [];
    this.licenseForm.controls['ChildWorkOrderCode'].setValue(null);
    this.licenseWorkOrderData.ChildWorkOrder_Code = null;

    if (!data) return;
    
    if (this.licenseMainData.ContractorVendor_Code) {
      this.licenseMainData.ContractorVendor_Code = data.ContractorVendor_Code;
    }
    
    const ContractorCode = this.licenseForm.controls['ParentContractorVendor_Code'].value;
    const workorderCode = this.licenseForm.controls['ParentWorkOrderCode'].value;
    const subContractorCode = this.licenseForm.controls['ContractorVendor_Code'].value;
    if (subContractorCode) {
      this.getSubContractorWorkOrder(ContractorCode, workorderCode, subContractorCode);
    }
  }

  public onSubContractorWOChange(data: any): void {
    if (!data) return;
    if (this.licenseWorkOrderData.ChildWorkOrder_Code) {
      this.licenseWorkOrderData.ChildWorkOrder_Code = data.WorkOrder_Code;
    }
  }

  public onStartDateChange(): void {
    if (this.licenseForm.controls['StartDate'].valid) {
      //this.licenseForm.controls['StartDate'].patchValue(new Date((new Date(this.licenseForm.controls['StartDate'].value)).getTime() + (60 * 60 * 24 * 1000)));
      const startDate = this.licenseForm.controls['StartDate'].value;
      const date = moment(startDate).format('DD/MM/YYYY');
      const currentDate = moment(new Date()).format('DD/MM/YYYY');
      if (date === currentDate) {
      } else if (startDate < new Date()) {
        // this.licenseForm.controls['StartDate'].setValue('');
        if (this.allowedIssueDate == 1) {
          this.alertOption = {
            title: 'OOPS!!!',
            html: `<span class='customClass'>Please enter current date or greater than current date.</span>`,
            type: 'warning'
          };
          this.openAlert();
        }
        // return;
      }
      const licenseTypeMasterListCode = this.licenseForm.controls['LicenseTypeMasterList_Code'].value;
      this.maxEndDate = this.setEndDateByLicenceType(licenseTypeMasterListCode, startDate);
      // this.isValidStartDate = true;
      this.licenseForm.controls['EndDate'].enable();
      this.minEndDate = new Date((new Date(startDate)).getTime() + (60 * 60 * 24 * 1000));
      //this.minEndDate = startDate;
      if (this.isAcknowledgmentNatureSelected) {
        this.applyAcknowledgmentValidityDate(startDate);
      }
      const endDate = this.licenseForm.controls['EndDate'].value;
      if (startDate > endDate) {
        if (this.licenseForm.controls['EndDate'].valid) {
          this.licenseForm.controls['EndDate'].setValue('');
          // this.isValidStartDate = true;
        }
      }
    } else {
      this.licenseForm.controls['EndDate'].disable();
      this.licenseForm.controls['EndDate'].setValue('');
    }
  }

  private applyAcknowledgmentValidityDate(startDate: any, emitEvent: boolean = false): void {
    if (!this.licenseForm || !this.licenseForm.controls || !this.licenseForm.controls['EndDate']) {
      return;
    }
    const endDateControl = this.licenseForm.controls['EndDate'];
    const acknowledgmentEndDate = moment(startDate).add(1, 'month').toDate();
    this.minEndDate = acknowledgmentEndDate;
    endDateControl.setValue(acknowledgmentEndDate, { emitEvent });
    this.licenseForm.controls['EndDate'].setValue(acknowledgmentEndDate);
  }

  public enforceAcknowledgmentValidityDate(): void {
    if (!this.isAcknowledgmentNatureSelected) {
      return;
    }
    const startDate = this.licenseForm && this.licenseForm.controls ? this.licenseForm.controls['StartDate'].value : null;
    if (!startDate) {
      return;
    }
    this.applyAcknowledgmentValidityDate(startDate);
  }

  private normalizeText(value?: string): string {
    return value ? value.trim().toLowerCase() : '';
  }

  private getRequiredDocumentNamesForLicense(licenseCode: number): string[] | undefined {
    if (!licenseCode || !this.natureOfLicenseList.length) {
      return undefined;
    }
    const selectedLicense = this.natureOfLicenseList.find((item) => Number(item.MasterItem_Code) === Number(licenseCode));
    if (!selectedLicense) {
      return undefined;
    }
    const normalizedName = this.normalizeText(selectedLicense.Name);
    return this.licenseDocumentRules[normalizedName];
  }

  private setDocumentMandatoryBasedOnLicense(): void {
    if (!this.documentTypes || !this.documentTypes.length) {
      return;
    }
    const licenseCode = this.licenseForm && this.licenseForm.controls ? this.licenseForm.controls['LicenseTypeMasterList_Code'].value : null;
    const requiredDocNames = this.getRequiredDocumentNamesForLicense(licenseCode);
    const hasSpecificDocs = !!(requiredDocNames && requiredDocNames.length);

    this.documentTypes = this.documentTypes.map((doc) => {
      const normalizedDocName = this.normalizeText(doc.Name);
      const storedKey = String(doc.DocumentType_Code);
      const storedMandatory = this.documentTypeDefaultMandatoryMap.hasOwnProperty(storedKey)
        ? this.documentTypeDefaultMandatoryMap[storedKey]
        : doc.IsMandatory;
      const isMandatoryForLicense = hasSpecificDocs
        ? requiredDocNames.some((name) => name === normalizedDocName)
        : undefined;

      return {
        ...doc,
        IsMandatory: typeof isMandatoryForLicense === 'boolean' ? isMandatoryForLicense : storedMandatory
      };
    });
    this.bindCheckList();
  }

  public onNatureOfLicenceChange() {

    const licenseTypeMasterListCode = this.licenseForm.controls['LicenseTypeMasterList_Code'].value;
    if (licenseTypeMasterListCode) {
      this.licenseForm.controls['StartDate'].enable();
      this.licenseForm.controls['StartDate'].setValue('');
      this.licenseForm.controls['EndDate'].setValue('');
      if (this.isAcknowledgmentNatureSelected) {
        this.enforceAcknowledgmentValidityDate();
      }
    } else {
      this.licenseForm.controls['StartDate'].disable();
      this.licenseForm.controls['EndDate'].disable();

      this.licenseForm.controls['StartDate'].setValue('');
      this.licenseForm.controls['EndDate'].setValue('');

    }
    this.setDocumentMandatoryBasedOnLicense();
  }

  isFileChanged: boolean = false
  public onFilesChanged(newFiles: any[]) {
    this.isDocumentStepTouched = true;
    this.isFileChanged = true
    this.uploadedFiles = newFiles;

  }
  saveOnly(): void {
    this.onSubmit(this.licenseForm.value, false);
  }
  public saveAndNew(): void {
    this.onSubmit(this.licenseForm.value, true);
  }
  // save() {
  //
  //   this.onSubmit(this.licenseForm.value, true);
  //
  //   this.router.navigate(['contractor/licences']);
  //   this.clearForm();
  // }
  isContractorSelected: boolean = false
  isonNatureOfWorkChange: boolean = false
  onNatureOfWorkObj: any
  onNatureOfWorkChange(selectedNatureOfWork: any) {
    this.isonNatureOfWorkChange = true
    this.onNatureOfWorkObj = selectedNatureOfWork.map(item => {
      return {
        ID: item.$id,
        NatureOfWork_Code: item.NatureOfWork_Code,
      };
    });
    this.onNatureOfWorkObj.forEach(item => {
      item.License_Code = this.activatedRoute.snapshot.params.id;
      item.CreateBy = this.loginUserId;
    });
  }

  selectedePlantData: any
  onChangePlant(selectedPlant: any) {
    const stateCode = this.licenseForm.controls['State_Code'].value;
    
    if (!stateCode) {
      this.showAlert('error', 'Please select State first before selecting Plant.', 'Error!!!');
      this.licenseForm.controls['Plants'].setValue(null);
      return;
    }
    
    this.selectedePlantData = selectedPlant;
    
    // Reload work orders when plant changes
    const contractorCode = this.licenseForm.controls['ParentContractorVendor_Code'].value;
    if (contractorCode && selectedPlant) {
      this.getContractorWorkOrder(contractorCode);
    }
  }

  loginUserId: string | null = GLOBAL.USER_ID;
  resultArray: any = [];
  updateAndNew(form: NgForm): void {
    if (form.valid) {
      const formData = form.value;
      if (this.isonNatureOfWorkChange) {
        this.licenseNatureOfWorkData.forEach(item1 => {
          let matchFound = false;
          let matchInArray2 = this.onNatureOfWorkObj.find(item2 => item2.NatureOfWork_Code === item1.NatureOfWork_Code);

          if (matchInArray2) {
            this.resultArray.push({
              ...matchInArray2,
              ID: item1.ID,
            });
            matchFound = true;
            const indexToRemove = this.resultArray.findIndex(item => item.NatureOfWork_Code === item1.NatureOfWork_Code);
            if (indexToRemove !== -1) {
              this.resultArray.splice(indexToRemove, 1);
            }
          }
          if (!matchFound) {
            this.resultArray.push({ ID: { oldValue: item1.ID, newValue: item1.ID }, CreateBy: { oldValue: this.loginUserId, newValue: this.loginUserId }, isdelete: { OldValue: 0, NewValue: 1 } });
          }
        });
      }

      const payload = {
        "055D8F4B-D2F5-4483-803A-962B4F2CEEC6": {},
        "A1566D61-0B04-4D65-8DE6-895DC89F6E8D":{}
      };
      const addToPayloadIfChanged = (key, oldValue, newValue) => {
        if (key === "License_Code" || oldValue !== newValue) {
          if (!payload["055D8F4B-D2F5-4483-803A-962B4F2CEEC6"]) {
            payload["055D8F4B-D2F5-4483-803A-962B4F2CEEC6"] = {};
          }

          payload["055D8F4B-D2F5-4483-803A-962B4F2CEEC6"][key] = {
            OldValue: oldValue,
            NewValue: newValue
          };
        }
      };
      addToPayloadIfChanged("License_Code", this.licenseMainData.License_Code, this.licenseMainData.License_Code);
      if (this.isContractorSelected) {
        if (!this.isSubContractor) {
          addToPayloadIfChanged("ContractorVendor_Code", this.licenseMainData.ContractorVendor_Code, this.selectedContractorData.ContractorVendor_Code != undefined && this.selectedContractorData.ContractorVendor_Code != null ? this.selectedContractorData.ContractorVendor_Code : this.licenseMainData.ContractorVendor_Code);
          addToPayloadIfChanged("ParentContractorVendor_Code", this.licenseMainData.ParentContractorVendor_Code, this.selectedContractorData.ContractorVendor_Code != undefined && this.selectedContractorData.ContractorVendor_Code != null ? this.selectedContractorData.ContractorVendor_Code : this.licenseMainData.ContractorVendor_Code);
        } else {
          addToPayloadIfChanged("ContractorVendor_Code", this.licenseMainData.ContractorVendor_Code, this.selectedContractorData.ContractorVendor_Code != undefined && this.selectedContractorData.ContractorVendor_Code != null ? this.selectedContractorData.ContractorVendor_Code : this.licenseMainData.ContractorVendor_Code);
          addToPayloadIfChanged("ParentContractorVendor_Code", this.licenseMainData.ParentContractorVendor_Code, this.selectedContractorData.ContractorVendor_Code != undefined && this.selectedContractorData.ContractorVendor_Code != null ? this.selectedContractorData.ContractorVendor_Code : this.licenseMainData.ContractorVendor_Code);
        }
      }
      addToPayloadIfChanged("LicenseNo", this.licenseMainData.LicenseNo, formData.LicenseNo);
      addToPayloadIfChanged("LinNumber", this.licenseMainData.LinNumber, formData.LinNumber);
      addToPayloadIfChanged("LicenseTypeMasterList_Code", this.licenseMainData.LicenseTypeMasterList_Code, formData.LicenseTypeMasterList_Code);
      addToPayloadIfChanged("Person", this.licenseMainData.Person, formData.Person);
      addToPayloadIfChanged("StartDate", this.licenseMainData.StartDate, moment(formData.StartDate).format('YYYY-MM-DDTHH:mm:ss'));
      addToPayloadIfChanged("EndDate", this.licenseMainData.EndDate, moment(formData.EndDate).format('YYYY-MM-DDTHH:mm:ss'));
      addToPayloadIfChanged("Comment", this.licenseMainData.Comment, formData.Comment);
      addToPayloadIfChanged("Version", this.licenseMainData.Version, this.licenseMainData.Version + 1);
      addToPayloadIfChanged("CreateBy", this.loginUserId, this.loginUserId);
      addToPayloadIfChanged("ModifiedBy", this.loginUserId, this.loginUserId);

      if (this.isonNatureOfWorkChange) {
        payload["055D8F4B-D2F5-4483-803A-962B4F2CEEC6"]["8B5A9A65-010F-458D-A400-9B5D6C449D72"] = this.resultArray[0];
      }

      if (this.isContractorSelected) {
        const payload2 = {
          "A1566D61-0B04-4D65-8DE6-895DC89F6E8D": {}
        };
        const addToPayload2IfChanged = (key, oldValue, newValue) => {
          if (oldValue !== newValue) {
            payload2["A1566D61-0B04-4D65-8DE6-895DC89F6E8D"][key] = { OldValue: oldValue, NewValue: newValue };
          }
        };
        const addToPayload2Always = (key, value) => {
          payload2["A1566D61-0B04-4D65-8DE6-895DC89F6E8D"][key] = { OldValue: value, NewValue: value };
        };
        addToPayload2Always("License_Code", this.licenseMainData.License_Code);
        addToPayload2Always("ID", this.licenseWorkOrderData.ID);
        addToPayload2Always("CreateBy", this.loginUserId);
        addToPayload2Always("ModifiedBy", this.loginUserId);
        addToPayload2IfChanged("ParentWorkOrder_Code", this.licenseWorkOrderData.ParentWorkOrder_Code, formData.ParentWorkOrderCode);
        if (this.isSubContractor) {
          addToPayload2IfChanged("ChildWorkOrder_Code", this.licenseWorkOrderData.ChildWorkOrder_Code, formData.ChildWorkOrder_Code);
        }
        addToPayload2IfChanged("Plant_Code", this.licenseWorkOrderData.Plant_Code, formData.Plants);
        // Add state code to payload when plant is selected
        if (formData.Plants) {
          const stateCode = this.licenseForm.controls['State_Code'].value;
          addToPayload2IfChanged("State_Code", this.licenseMainData.State_Code, stateCode);
        }
        if (Object.keys(payload2["A1566D61-0B04-4D65-8DE6-895DC89F6E8D"]).length > 0) {
          debugger
          payload["A1566D61-0B04-4D65-8DE6-895DC89F6E8D"] = payload2["A1566D61-0B04-4D65-8DE6-895DC89F6E8D"];
        }
      }


      if (this.isFileChanged) {
        let unmatchedIDs = [];
        this.licenseDocumentData.forEach(item1 => {
          let matchFound = false;
          let matchInArray1 = this.uploadedFiles.find(item2 => item2.ID === item1.ID);

          if (matchInArray1) {
            unmatchedIDs.push({
              ...matchInArray1,
              ID: item1.ID,
            });
            matchFound = true;
            const indexToRemove = unmatchedIDs.findIndex(item => item.ID === item1.ID);
            if (indexToRemove !== -1) {
              unmatchedIDs.splice(indexToRemove, 1);
            }
          }
          if (!matchFound) {
            unmatchedIDs.push({ ID: { oldValue: item1.ID, newValue: item1.ID }, isdelete: { OldValue: 0, NewValue: 1 } });
          }
        })
        payload["055D8F4B-D2F5-4483-803A-962B4F2CEEC6"]["4E3A518F-CAF3-4938-A2B0-7C9D2660F85A"] = unmatchedIDs[0];
      }

      this.licenseService.updateLicense(payload).subscribe((response) => {
        if (response) {
          if (form.valid) {
            this.showLicenseInfo(false, true);
          }
        }
      });
    }
  }

  // public updateAndNew(res:any): void {
  //   this.onSubmit(this.licenseForm.value, true);
  // }

  filterPayload(payload: any): any {
    if (Array.isArray(payload)) {
      return payload
        .map((item) => this.filterPayload(item))
        .filter((item) => Object.keys(item).length > 0); // Remove empty objects
    } else if (typeof payload === "object" && payload !== null) {
      const filteredObject: any = {};
      for (const key in payload) {
        const value = payload[key];
        if (value && typeof value === "object" && "OldValue" in value && "NewValue" in value) {
          if (value.OldValue !== value.NewValue) {
            filteredObject[key] = value;
          }
        } else {
          const nested = this.filterPayload(value);
          if (nested && (Array.isArray(nested) ? nested.length : Object.keys(nested).length)) {
            filteredObject[key] = nested;
          }
        }
      }
      return filteredObject;
    }
    return payload;
  }


  public clearForm(): void {
    this.licenseForm.reset();
    this.lastCheckedLicenseNo = ''; // Reset the last checked value
  }

  public onCancel() {
    this.router.navigate(['/contractor/licences']);
  }

  public onSubmit(formValue: any, saveAndNew: boolean): void {

    const mandatoryDocs = this.documentTypes.filter(doc => doc.IsMandatory === true);
    let hasMissingMandatoryDoc = false;

    if (mandatoryDocs.length > 0) {
      hasMissingMandatoryDoc = mandatoryDocs.some(mandatoryDoc => {
        return !this.uploadedFiles.some(uploadedFile =>
          uploadedFile.documentTypeCode === mandatoryDoc.DocumentType_Code
        );
      });
    }

    if (hasMissingMandatoryDoc) {
      this.showAlert('error', 'Please add license documents.', 'Error!!!');
      return;
    }

    //create license
    if (!this.licenseFormDataSnapshot || !Object.keys(this.licenseFormDataSnapshot).length) {
      let licenseObj: any;
      licenseObj = { ...this.licenseMainData, ...formValue };
      const startDateControl = this.licenseForm && this.licenseForm.controls
        ? this.licenseForm.controls['StartDate']
        : null;
      const endDateControl = this.licenseForm && this.licenseForm.controls
        ? this.licenseForm.controls['EndDate']
        : null;
      if (!licenseObj.StartDate && startDateControl) {
        licenseObj.StartDate = startDateControl.value;
      }
      if (!licenseObj.EndDate && endDateControl) {
        licenseObj.EndDate = endDateControl.value;
      }
      licenseObj.roleCode = JSON.parse(localStorage.getItem('Role'))[0].Role_Code;
      licenseObj.CreateBy = GLOBAL.USER_ID;
      licenseObj.StartDate = new Date((new Date(licenseObj.StartDate)).getTime() + (60 * 60 * 24 * 1000));
      licenseObj.EndDate = new Date((new Date(licenseObj.EndDate)).getTime() + (60 * 60 * 24 * 1000));
      if (!this.isSubContractor) {
        licenseObj.ContractorVendor_Code = licenseObj.ParentContractorVendor_Code;
        licenseObj.ParentContractorVendor_Code = null;
      }
      licenseObj.DocumentImageMasterViews = [];
      const filesToUpload = this.getNotUploadedItems(this.uploadedFiles);
      licenseObj.filesToUpload = filesToUpload.length ? filesToUpload : [];
      licenseObj.NatureOfWorkList = licenseObj.NatureOfWorkList && licenseObj.NatureOfWorkList.length ? licenseObj.NatureOfWorkList : [];
      
      // Add state code to license object when plant is selected
      if (licenseObj.Plants) {
        licenseObj.State_Code = this.licenseForm.controls['State_Code'].value;
      }
      Promise.all(
        licenseObj.filesToUpload.map(async (fileDoc) => {
          const base64str = await this.fileToBase64(fileDoc['file']); // Convert file to Base64
          return { ...fileDoc, base64str }
        })
      ).then((filesArray) => {
        licenseObj.filesToUpload = filesArray;
        this.licenseService.addLicense(licenseObj).pipe(takeUntil(this.onDestroy)).subscribe(
          (response: any) => {
            if (response) {
              if (saveAndNew) {
                this.showLicenseInfo(true, false);
                this.resetFormAfterSave();
              } else {
                this.showLicenseInfo(true, true);
              }
            } else {
              this.alertOption = {
                title: 'Error!!!',
                html: `<span class='customClass'>Some Error has occured! Please try again.</span>`,
                type: 'error'
              };
              this.openAlert();
            }
          }
        );
      });
    }
    else {
      
      this.updateAndNew(this.licenseForm);

      // The previous code here was commented out and hardcoded to show an error:
      /* this.alertOption = {
        title: 'Error!!!',
        html: `<span class='customClass'>Some error has occured! Please try again.</span>`,
        type: 'error'
      };
      this.openAlert(); 
      */
    }
  }
  private fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = (reader.result as string).split(',')[1]; // Remove data URI prefix
        resolve(base64String);
      };
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file); // Read file as Base64
    });
  };

  // private saveDocuments(licenseCode: any, saveAndNew: boolean, isAdd: boolean) {
  //   console.log('saveDocuments response', licenseCode);

  //   const uploadParams = {
  //     License_Code: licenseCode
  //   };
  //   const filesToUpload = this.getNotUploadedItems(this.uploadedFiles);
  //   if (uploadParams.License_Code && filesToUpload.length > 0) {
  //     this.licenseService.uploadDocuments(filesToUpload, uploadParams)
  //       .pipe(takeUntil(this.onDestroy)).subscribe((res) => {
  //         if (saveAndNew) {
  //           this.showLicenseInfo(isAdd, false);
  //           this.resetFormAfterSave();
  //         } else {
  //           this.showLicenseInfo(isAdd, true);
  //         }
  //       });
  //   } else if (saveAndNew) {
  //     this.showLicenseInfo(isAdd, false);
  //     this.resetFormAfterSave();
  //   } else {
  //     this.showLicenseInfo(isAdd, true);
  //   }
  // }

  private showLicenseInfo(isAdd: boolean, redirect: boolean) {

    const message = isAdd ? 'License detail is successfully added.' : 'License detail is successfully updated.';
    this.alertOption = {
      title: 'Success!!!',
      html: `<span class='customClass'>${message}</span>`,
      type: 'success',
      timer: 2000
    };
    this.openAlert();
    if (redirect) {
      setTimeout(() => {
        this.router.navigate(['contractor/licences']);
      }, 3000);
    }
    // this.clearForm();
  }

  private getNotUploadedItems(files: any[]) {
    return files.filter((item: any) => !item.isUploaded);
  }

  private setEndDateByLicenceType(licenseTypeMasterListCode: number, startDate: any): Date {
    let maxDate = null;
    if (licenseTypeMasterListCode === NatureOfLicenceCode.Acknowledgment) {
      maxDate = new Date(new Date(startDate).setMonth(new Date(startDate).getMonth() + 1));
    } else {
      maxDate = new Date(new Date(startDate).setFullYear(new Date(startDate).getFullYear() + 1));
    }
    return maxDate;
  }

  private checkContractorType(): boolean {
    let isValidType = false;
    const id: string = this.activatedRoute.snapshot.params.id;
    if (id) {
      isValidType = true;
      this.editMode = true;
    } else {
      const type: string = this.activatedRoute.snapshot.queryParamMap.get('type');
      if (type === '1' || type === '0') {
        this.isSubContractor = type === '0';
        isValidType = true;
      }
    }
    return isValidType;
  }

  private checkMandatoryDocuments(): boolean {
    if (!this.documentTypes || this.documentTypes.length === 0) {
      return false;
    }

    const mandatoryDocs = this.documentTypes.filter(doc => doc.IsMandatory === true);

    if (mandatoryDocs.length === 0) {
      return true;
    }

    const allMandatoryPresent = mandatoryDocs.every(mandatoryDoc => {
      return this.uploadedFiles.some(uploadedFile =>
        uploadedFile.documentTypeCode === mandatoryDoc.DocumentType_Code
      );
    });

    return allMandatoryPresent;
  }

  private bindWizardSteps() {
    this.wizardSteps = [
      {
        id: 'licenseDetails',
        name: 'License Info',
        isValid: () => {
          // return true;
          return this.wizard1Validation();
        },
      },
      {
        id: 'documentDetails',
        name: 'Documents',
        isValid: () => {
          return this.checkMandatoryDocuments();
        }
      }];
  }
  // tslint:disable-next-line: function-name
  CheckLicenceNo() {
    const currentLicenseNo = this.licenseForm.controls.LicenseNo.value;
    
    // Don't call API if field is empty or value hasn't changed
    if (!currentLicenseNo || currentLicenseNo.trim() === '' || currentLicenseNo === this.lastCheckedLicenseNo) {
      return true;
    }
    
    // Update the last checked value
    this.lastCheckedLicenseNo = currentLicenseNo;
    
    const id = this.activatedRoute.snapshot.params.id;
    this.licenseService.checkLicenseNoAvailability(currentLicenseNo, id).subscribe((res: any) => {
      this.licenceno = res.Data;
      if (this.licenceno > 0) {
        this.alertOption = {
          title: 'Error!!!',
          html: `<span class='customClass'>That License no already exists.  Enter correct value or different.</span>`,
          type: 'error'
        };
        this.openAlert();
        this.licenseForm.controls['LicenseNo'].reset();
        this.lastCheckedLicenseNo = ''; // Reset since we cleared the field
      }
    });
    return true;
  }
  private wizard1Validation(): boolean {
    let flag = false;
    if (this.licenseForm.controls.State_Code) {
      flag = this.licenseForm.controls.State_Code.valid
        && this.licenseForm.controls.LicenseTypeMasterList_Code.valid
        && this.licenseForm.controls.Company.valid
        && this.licenseForm.controls.Plants.valid
        && this.licenseForm.controls.ParentContractorVendor_Code.valid
        && this.licenseForm.controls.ParentWorkOrderCode.valid
        && this.licenseForm.controls.LicenseNo.valid
        && this.licenseForm.controls.Person.valid
        && this.licenseForm.controls.StartDate.valid
        && this.licenseForm.controls.EndDate.valid
        && this.licenseForm.controls.NatureOfWorkList.valid
        && this.licenseForm.controls.LinNumber.valid;

      if (flag) {
        flag = this.checkValidEndDate();
      }

      if (flag && this.isSubContractor) {
        flag = this.licenseForm.controls.ContractorVendor_Code.valid
          && this.licenseForm.controls.ChildWorkOrderCode.valid;
      }
    }
    return flag;
  }

  private checkValidEndDate() {
    if (this.licenseForm.controls.StartDate.value !== '' && this.licenseForm.controls.EndDate.value !== '') {
      const startDate: Date = new Date(this.licenseForm.controls.StartDate.value);
      const endDate: Date = new Date(this.licenseForm.controls.EndDate.value);
      if (startDate > endDate) {
        return false;
      }
    }
    return true;
  }

  private getLicense() {
    const id = this.activatedRoute.snapshot.params.id;
    if (id) {
      this.licenseService.getLicenseByLicenseCode(id).pipe(takeUntil(this.onDestroy)).subscribe((response: any[]) => {
debugger
        if (Object.keys(response).length > 0) {
          this.licenseMainData = response['Table1'][0];
          this.licenseWorkOrderData = response['Table2'][0];
          this.licenseNatureOfWorkData = response['Table3'];
          this.licenseDocumentData = response['Table4'];
          if (this.licenseMainData.ParentContractorVendor_Code) {
            this.isSubContractor = true;
          } else {
            this.licenseMainData.ParentContractorVendor_Code = this.licenseMainData.ContractorVendor_Code;
            // this.licenseMainData.ContractorVendor_Code = null;
          }

          this.licenseFormDataSnapshot = {
            licenseMainData: this.licenseMainData,
            licenseWorkOrderData: this.licenseWorkOrderData,
            licenseNatureOfWorkData: this.licenseNatureOfWorkData,
            licenseDocumentData: this.licenseDocumentData,
          }

          this.getAllData();
          this.setControlValue(true);
        }
      });
    } else {
      this.licenseFormDataSnapshot = null;
      this.setDefaultLicenseObj();
      this.setControlValue(false);
      this.getAllData();
    }
  }

  private setDefaultLicenseObj() {
    this.licenseMainData = {
      ParentContractorVendor_Code: null,
      ContractorVendor_Code: null,
      Plants: null,
      SatusMasterList_Code: null,
      VerifyBy: null,
    };

    this.licenseWorkOrderData = {
      ParentWorkOrder_Code: null,
      ChildWorkOrder_Code: null,
    }

    this.licenseDocumentData = null;
    this.licenseNatureOfWorkData = null;
  }

  private setControlValue(isEdit: boolean): void {
    //patch document & preview document code
    this.uploadedFiles = [];
    if (this.licenseDocumentData && this.licenseDocumentData.length) {
      this.licenseDocumentData.forEach((fileConfig) => {
        this.uploadedFiles.push({
          ID: fileConfig.ID,
          file: {
            lastModified: fileConfig.ModifiedDate,
            name: fileConfig.UploadFileName
          },
          documentTypeCode: fileConfig.DocumentTypeMasterList_Code,
          isUploaded: true,
          url: this.constructDocumentPreviewPath(fileConfig)
        });
      });
    }

    this.licenseForm.controls['ParentContractorVendor_Code'].setValue(this.licenseMainData.ParentContractorVendor_Code);
    this.licenseForm.controls['ParentWorkOrderCode'].setValue(this.licenseWorkOrderData.ParentWorkOrder_Code);
    if (this.licenseForm.controls['ContractorVendor_Code']) {
      this.licenseForm.controls['ContractorVendor_Code'].setValue(this.licenseMainData.ContractorVendor_Code);
    }
    if (this.licenseForm.controls['ChildWorkOrderCode']) {
      this.licenseForm.controls['ChildWorkOrderCode'].setValue(this.licenseWorkOrderData.ChildWorkOrder_Code);
    }
    this.licenseForm.controls['LicenseNo'].setValue(this.licenseMainData.LicenseNo);
    this.headerTitleName = this.licenseMainData.LicenseNo;
    // Set the last checked value to current license number to prevent unnecessary API calls
    this.lastCheckedLicenseNo = this.licenseMainData.LicenseNo || '';
    this.licenseForm.controls['Person'].setValue(this.licenseMainData.Person);
    this.licenseForm.controls['StartDate'].setValue(this.licenseMainData.StartDate);
    this.licenseForm.controls['EndDate'].setValue(this.licenseMainData.EndDate);
    this.licenseForm.controls['LinNumber'].setValue(this.licenseMainData.LinNumber);
    this.licenseForm.controls['ExtensionDate'].setValue(this.licenseMainData.ExtensionDate);
    this.licenseForm.controls['VerifyDate'].setValue(this.licenseMainData.VerifyDate);
    // this.licenseForm.controls['VerifyBy'].setValue(this.license.VerifyBy);
    this.licenseForm.controls['Comment'].setValue(this.licenseMainData.Comment);
    if (isEdit) {
      this.isValidStartDate = true;
      this.licenseForm.controls['EndDate'].enable();
      this.minEndDate = new Date((new Date(this.licenseMainData.StartDate)).getTime() + (60 * 60 * 24 * 1000));
      // this.maxEndDate = this.setEndDateByLicenceType(this.license.LicenseTypeMasterList_Code, this.license.StartDate);
    }
  }

  private getAllData() {
    this.getStates();
    this.getCompanies();
    this.getNatureOfLicense();
    this.getStatus();
    this.getNatureOfWorks();
    this.getVerifyByList();
  }

  private getStates(): void {
    this.licenseService.getState().pipe(takeUntil(this.onDestroy)).subscribe((response: any[]) => {
      this.stateList = response;
      this.licenseForm.controls['State_Code'].setValue(this.licenseMainData.State_Code);
    });
  }

  private getCompanies(): void {
    this.licenseService.getCompanies().pipe(takeUntil(this.onDestroy)).subscribe((response: any[]) => {
      this.companyList = response;

      // Only set company value if we have existing data (edit mode)
      if (!isNullOrUndefined(this.licenseMainData.Company_Code)) {
        this.licenseForm.controls['Company'].setValue(this.licenseMainData.Company_Code);
        this.getPlants(this.licenseMainData.Company_Code, this.licenseMainData.State_Code);
      } 
      // Auto-select if only one company is available
      else if (this.companyList.length === 1) {
        this.licenseForm.controls['Company'].setValue(this.companyList[0].Company_Code);
        // Trigger company change to load plants if state is already selected
        const stateCode = this.licenseForm.controls['State_Code'].value;
        if (stateCode) {
          this.getPlants(this.companyList[0].Company_Code, stateCode);
        }
      } else {
        this.licenseForm.controls['Company'].setValue(null);
      }
    });
  }

  getContractors() {

    this.licenseService.getContractors(false).pipe(takeUntil(this.onDestroy)).subscribe((response: any[]) => {
      this.contractorList = response;

      // Only set contractor value if we have existing data (edit mode)
      if (this.licenseMainData.ParentContractorVendor_Code) {
        this.licenseForm.controls['ParentContractorVendor_Code'].setValue(this.licenseMainData.ParentContractorVendor_Code);
        this.getContractorWorkOrder(this.licenseMainData.ParentContractorVendor_Code);
      }
      // Remove auto-selection - let user select manually
    });
  }

  public getNatureOfLicense(): void {
    this.licenseService.getMasterItemListByCode(MasterItemCode.NATURE_OF_LICENSE).pipe(takeUntil(this.onDestroy))
      .subscribe((response: any[]) => {
        this.natureOfLicenseList = response;
        
        // Only set value if we have existing data (edit mode)
        if (this.licenseMainData.LicenseTypeMasterList_Code) {
          this.licenseForm.controls['LicenseTypeMasterList_Code'].setValue(this.licenseMainData.LicenseTypeMasterList_Code);
        }
        // Remove auto-selection - let user select manually
      });
  }

  private getStatus(): void {
    this.licenseService.getMasterItemListByCode(MasterItemCode.STATUS_CODE).pipe(takeUntil(this.onDestroy))
      .subscribe((response: any[]) => {
        this.statuses = response;

        this.licenseForm.controls['SatusMasterList_Code'].setValue(this.licenseMainData.SatusMasterList_Code);
      });
  }

  private getNatureOfWorks(): void {
    this.licenseService.getNatureOfWorks().pipe(takeUntil(this.onDestroy)).subscribe((response: any) => {
      this.natureOfWorkList = response;

      if (this.licenseNatureOfWorkData.length) {
        this.licenseForm.controls['NatureOfWorkList'].setValue(this.licenseNatureOfWorkData.map((e) => e.NatureOfWork_Code));
      }
    });
  }

  private getSubContractorsByWorkOrder(contractorCode, workorderCode): void {

    this.licenseService.getContractors(true, contractorCode, workorderCode).pipe(takeUntil(this.onDestroy)).subscribe((response: any[]) => {
      this.subContractorList = response;
      if (this.licenseMainData.ContractorVendor_Code) {
        this.licenseForm.controls['ContractorVendor_Code'].setValue(this.licenseMainData.ContractorVendor_Code);
        this.getSubContractorWorkOrder(contractorCode, workorderCode, this.licenseMainData.ContractorVendor_Code);
      }
      else {
        if (this.subContractorList.length === 1) {
          this.licenseForm.controls['ContractorVendor_Code'].patchValue(this.subContractorList[0].ContractorVendor_Code);
          this.getSubContractorWorkOrder(contractorCode, workorderCode, this.subContractorList[0].ContractorVendor_Code);
        }
      }
    });
  }


  private getPlants(companyCode: any, stateCode?: any): void {
    this.licenseService.getPlants(companyCode, stateCode).pipe(takeUntil(this.onDestroy)).subscribe((response: any) => {
      this.plantList = response;

      // Only set plant value if we have existing data (edit mode)
      if (this.licenseMainData.Plant_Code) {
        this.licenseForm.controls['Plants'].setValue(Number(this.licenseMainData.Plant_Code));
      } 
      // Fallback check: sometimes the API might actually return 'Plants'
      else if (this.licenseMainData.Plants) {
        this.licenseForm.controls['Plants'].setValue(Number(this.licenseMainData.Plants));
      }
      // Check work order data for plant code
      else if (this.licenseWorkOrderData && this.licenseWorkOrderData.Plant_Code) {
        this.licenseForm.controls['Plants'].setValue(Number(this.licenseWorkOrderData.Plant_Code));
      }
      // Auto-select plant only when both state and company are selected and only one plant is available
      else if (stateCode && companyCode && this.plantList.length === 1) {
        this.licenseForm.controls['Plants'].setValue(this.plantList[0].Plant_Code);
      }
    });
  }

  private getContractorWorkOrder(contractorCode: number): void {
    const plantCode = this.licenseForm.controls['Plants'].value;
    
    if (!contractorCode) {
      this.contractorWorkOrderList = [];
      return;
    }
    
    // If plant is not selected but we have state and company, try to load plants first
    if (!plantCode) {
      const stateCode = this.licenseForm.controls['State_Code'].value;
      const companyCode = this.licenseForm.controls['Company'].value;
      
      if (stateCode && companyCode) {
        this.getPlants(companyCode, stateCode);
      }
    }
    
    this.licenseService.getWorkOrderFilterData(contractorCode, plantCode).pipe(takeUntil(this.onDestroy)).subscribe((response: any[]) => {
      this.contractorWorkOrderList = response;
      if (this.licenseWorkOrderData.ParentWorkOrder_Code) {
        this.licenseForm.controls['ParentWorkOrderCode'].setValue(this.licenseWorkOrderData.ParentWorkOrder_Code);
        if (this.isSubContractor) {
          this.getSubContractorsByWorkOrder(contractorCode, this.licenseWorkOrderData.ParentWorkOrder_Code);
        }
      }
      else {
        if (this.contractorWorkOrderList.length === 1) {
          this.licenseForm.controls['ParentWorkOrderCode'].patchValue(this.contractorWorkOrderList[0].WorkOrder_Code);
          if (this.isSubContractor) {
            this.getSubContractorsByWorkOrder(contractorCode, this.contractorWorkOrderList[0].WorkOrder_Code);
          }
        }
      }
    });
  }

  private getSubContractorWorkOrder(contractorCode, workorderCode, subContractorCode: number): void {
    const plantCode = this.licenseForm.controls['Plants'].value;
    
    this.licenseService.getWorkOrderFilterDataForSubWorkorder(contractorCode, subContractorCode, workorderCode, plantCode).pipe(takeUntil(this.onDestroy)).subscribe((response: any[]) => {
      this.subContractorWorkOrderList = response;
      if (this.licenseWorkOrderData.ChildWorkOrder_Code) {
        this.licenseForm.controls['ChildWorkOrderCode'].setValue(this.licenseWorkOrderData.ChildWorkOrder_Code);
      }
      else {
        if (this.subContractorWorkOrderList.length === 1) {
          this.licenseForm.controls['ChildWorkOrderCode'].patchValue(this.subContractorWorkOrderList[0].WorkOrder_Code);
        }
      }
    });
  }

  private getVerifyByList(): void {
    this.licenseService.getVerifyByList().pipe(takeUntil(this.onDestroy)).subscribe((response: any[]) => {
      console.log('getState response', response);
      this.verifyByList = response;
      this.licenseForm.controls['VerifyBy'].setValue(this.licenseMainData.VerifyBy ? this.licenseMainData.VerifyBy.toString() : null);
    });
  }

  private bindCheckList() {
    this.checkList = []; 

    this.checkList.push(
      {
        id: 1,
        text: 'Licenses Info',
        open: true,
        childrens: [
          {
            text: 'State',
            title: 'State',
            desc: 'State is required.',
            isValid: () => {
              return (this.licenseForm.controls.State_Code.valid);
            },
            hasError: () => {
              return ((this.licenseForm.controls.State_Code.dirty || this.licenseForm.controls.State_Code.touched)
                && this.licenseForm.controls.State_Code.invalid);
            },
            isMandatory: true,
            isVisible: true,
            step: '1',
          },
          {
            text: 'Company & Plant',
            title: 'Company & Plant',
            desc: 'Company and Plant is required.',
            isValid: () => {
              return (this.licenseForm.controls.Company.valid
                && this.licenseForm.controls.Plants.valid);
            },
            hasError: () => {
              return (((this.licenseForm.controls.Company.dirty
                || this.licenseForm.controls.Company.touched)
                && this.licenseForm.controls.Company.invalid)
                || ((this.licenseForm.controls.Plants.dirty
                  || this.licenseForm.controls.Plants.touched)
                  && this.licenseForm.controls.Plants.invalid));
            },
            isMandatory: true,
            isVisible: true,
            step: '1',
          },
          {
            text: 'Contractor Details',
            title: 'Contractor Details',
            desc: 'Contractor and Work Order is required.',
            isValid: () => {
              return (this.licenseForm.controls.ParentContractorVendor_Code.valid
                && this.licenseForm.controls.ParentWorkOrderCode.valid);
            },
            hasError: () => {
              return (((this.licenseForm.controls.ParentContractorVendor_Code.dirty
                || this.licenseForm.controls.ParentContractorVendor_Code.touched)
                && this.licenseForm.controls.ParentContractorVendor_Code.invalid)
                || ((this.licenseForm.controls.ParentWorkOrderCode.dirty
                  || this.licenseForm.controls.ParentWorkOrderCode.touched)
                  && this.licenseForm.controls.ParentWorkOrderCode.invalid));
            },
            isMandatory: true,
            isVisible: true,
            step: '1',
          },
          {
            text: 'License Details',
            title: 'License Details',
            desc: 'License No, Nature of license is required.',
            isValid: () => {
              return (this.licenseForm.controls.LicenseNo.valid
                && this.licenseForm.controls.LicenseTypeMasterList_Code.valid);
            },
            hasError: () => {
              return (((this.licenseForm.controls.LicenseNo.dirty || this.licenseForm.controls.LicenseNo.touched)
                && this.licenseForm.controls.LicenseNo.invalid)
                || ((this.licenseForm.controls.LicenseTypeMasterList_Code.dirty
                  || this.licenseForm.controls.LicenseTypeMasterList_Code.touched)
                  && this.licenseForm.controls.LicenseTypeMasterList_Code.invalid));
            },
            isMandatory: true,
            isVisible: true,
            step: '1',
          },
          {
            text: 'License Validity',
            title: 'License Validity',
            desc: 'Issue Date and Validity Date is required.',
            isValid: () => {
              return (this.licenseForm.controls.StartDate.valid
                && this.licenseForm.controls.EndDate.valid);
            },
            hasError: () => {
              return (((this.licenseForm.controls.StartDate.dirty || this.licenseForm.controls.StartDate.touched)
                && this.licenseForm.controls.StartDate.invalid)
                || ((this.licenseForm.controls.EndDate.dirty || this.licenseForm.controls.EndDate.touched)
                  && this.licenseForm.controls.EndDate.invalid));
            },
            isMandatory: true,
            isVisible: true,
            step: '1',
          },
          {
            text: 'Maximum Associates',
            title: 'Maximum Associates',
            desc: 'Maximum Associates is required.',
            isValid: () => {
              return (this.licenseForm.controls.Person.valid);
            },
            hasError: () => {
              return ((this.licenseForm.controls.Person.dirty
                || this.licenseForm.controls.Person.touched)
                && this.licenseForm.controls.Person.invalid);
            },
            isMandatory: true,
            isVisible: true,
            step: '1',
          },

        ]
      },
 );

    this.checkList.push(
      {
        id: 2,
        text: 'Documents',
        open: true,
        childrens: this.documentTypes
          .filter(doc => doc.IsMandatory === true)
          .map(doc => {
            return {
              text: doc.Name,
              title: doc.Name,
              desc: `Mandatory document: ${doc.Name}`,
              isValid: () => {
                return this.uploadedFiles.some(file => 
                  file.documentTypeCode === doc.DocumentType_Code
                );
              },
              hasError: () => {
                const isUploaded = this.uploadedFiles.some(file => 
                  file.documentTypeCode === doc.DocumentType_Code
                );
                return this.isDocumentStepTouched && !isUploaded;
              },
              isMandatory: true,
              isVisible: true,
              step: '2',
            };
          })
      }
    );

    if (this.isSubContractor) {
      const subContractorhekListObj = {
        text: 'Sub Contractor Details',
        title: 'Sub Contractor Details',
        desc: 'Sub Contractor and Sub-Work Order is required.',
        isValid: () => {
          return (this.licenseForm.controls.ContractorVendor_Code.valid
            && this.licenseForm.controls.ChildWorkOrderCode.valid);
        },
        hasError: () => {
          return (((this.licenseForm.controls.ContractorVendor_Code.dirty
            || this.licenseForm.controls.ContractorVendor_Code.touched)
            && this.licenseForm.controls.ContractorVendor_Code.invalid)
            || ((this.licenseForm.controls.ChildWorkOrderCode.dirty
              || this.licenseForm.controls.ChildWorkOrderCode.touched)
              && this.licenseForm.controls.ChildWorkOrderCode.invalid));
        },
        isMandatory: true,
        isVisible: true,
        step: '1',
      };
      this.checkList[0].childrens.splice(3, 0, subContractorhekListObj);
    }
  }

  private getDocumentTypes() {
    const res = {
      "Page_Code": 192,
      "RequireType": 1,
      "ActionType": 0,
      "SelectedField": "Name,DocumentType_Code,page_code,IsMandatory,IsAuthorized,IsBeforeApproval,UpdatedBy_RoleCode",
      "Search": null,
      "UserId": GLOBAL.USER_ID
    }
    this.licenseService.getDocumentTypesPageModuleWise(res).pipe(takeUntil(this.onDestroy)).subscribe((docTypes: any[]) => {
      this.documentTypes = docTypes.map((doc) => ({ ...doc }));
      this.documentTypeDefaultMandatoryMap = {};
      this.documentTypes.forEach((doc) => {
        this.documentTypeDefaultMandatoryMap[String(doc.DocumentType_Code)] = doc.IsMandatory;
      });
      this.setDocumentMandatoryBasedOnLicense();

    });
  }

  private showAlert(type: any, message: string, title: string) {
    this.alertOption = {
      title,
      type,
      html: `<span class='customClass'>${message}</span>`
    };
    this.openAlert();
  }

  private openAlert(): void {
    setTimeout(() => {
      const alertRef = this.dialogerror.show();
      alertRef.then((e) => {
      });
    }, 10);
  }

  private resetFormAfterSave() {
    const id = this.activatedRoute.snapshot.params.id;
    if (id) {
      const isDirect = this.licenseMainData.IsDirect;
      setTimeout(() => {
        if (isDirect) {
          this.router.navigate(['/contractor/add-licences/'], { queryParams: { type: '1' } });
        } else {
          this.router.navigate(['/contractor/add-licences/'], { queryParams: { type: '0' } });
        }
      }, 500);
    }

    this.licenseForm.reset();
    this.lastCheckedLicenseNo = ''; // Reset the last checked value
    this.setDefaultLicenseObj();
    this.setControlValue(false);
  }

  constructDocumentPreviewPath(file: any) {
    const url = GLOBAL.BASE_URL_DOC;
    if (file.ParentRootFolder && file.UploadFileName) {
      return url + "\\" + file.ParentRootFolder + file.UploadFileName;
    }
    return url;
  }
}
